/*
 * WOW Subpop - the "Switch To Subscription" popup shown after Add to cart.
 * Replaces Rebuy widget 262932 for visitors in group B.
 *
 * Arm A (Rebuy): this file does nothing.
 * Arm B (ours):  this file is the popup, and it keeps Rebuy's one from showing.
 *
 * The group comes from snippets/wow-cart-head.liquid (window.WowCartConfig),
 * the popup's own settings from snippets/wow-subpop.liquid (WowSubpopConfig).
 * Source of truth: storefront/wow-subpop/ in the WOW repo - never edit this in
 * the Shopify theme editor, the next deploy overwrites it.
 */
(function (root) {
  'use strict';

  /* ---------- pure helpers (unit-tested in storefront/wow-subpop/test) ---------- */

  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    var fmt = format || '${{amount}}';
    function withCommas(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas(Math.round(value), 0);
      return withCommas(value, 2);
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  // /cart/add answers with the line itself for a single item, and with
  // { items: [...] } when several were added in one request.
  function addedItems(json) {
    if (!json || typeof json !== 'object') return [];
    if (json.items && typeof json.items.length === 'number') return json.items;
    return json.variant_id ? [json] : [];
  }

  function hasPlan(item) {
    return !!(item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  }

  // Adds made by our own pieces (_wow_src) or by a Rebuy widget (_source) are
  // upsells, not the shopper's own Add to cart. Rebuy's popup stays shut for
  // those, so ours does too.
  function isWidgetAdd(item) {
    var p = (item && item.properties) || {};
    return !!p._wow_src || p._source === 'Rebuy';
  }

  // The one line the popup is about: the first thing just added that was
  // bought one-time. Rebuy's widget shows one product (limit 1).
  function offerItem(json) {
    var items = addedItems(json);
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].variant_id && !hasPlan(items[i]) && !isWidgetAdd(items[i])) return items[i];
    }
    return null;
  }

  // Rebuy rounds the saving down, not the price: $48.18 at 10% shows $43.37.
  function offerPrice(cents, percent) {
    var price = Number(cents) || 0;
    return price - Math.floor(price * (Number(percent) || 0) / 100);
  }

  function starPercent(rating) {
    return Math.max(0, Math.min(100, (Number(rating) / 5) * 100)) || 0;
  }

  // The cart line to switch. The line's key is the sure match; the variant is
  // the fallback for when another script rewrote the line in between.
  function findLine(cart, offer) {
    var lines = ((cart && cart.items) || []).filter(function (i) { return !hasPlan(i); });
    var byKey = lines.filter(function (i) { return i.key === offer.key; })[0];
    if (byKey) return byKey;
    return lines.filter(function (i) { return i.variant_id === offer.variant_id; })[0] || null;
  }

  function changePayload(line, planId, properties) {
    var props = {}, k;
    for (k in (line.properties || {})) {
      if (Object.prototype.hasOwnProperty.call(line.properties, k)) props[k] = line.properties[k];
    }
    for (k in (properties || {})) {
      if (Object.prototype.hasOwnProperty.call(properties, k)) props[k] = properties[k];
    }
    return { id: line.key, quantity: line.quantity, selling_plan: Number(planId), properties: props };
  }

  var helpers = {
    formatMoney: formatMoney, escapeHtml: escapeHtml, isCartAdd: isCartAdd, addedItems: addedItems,
    hasPlan: hasPlan, isWidgetAdd: isWidgetAdd, offerItem: offerItem, offerPrice: offerPrice,
    starPercent: starPercent, findLine: findLine, changePayload: changePayload
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = helpers; return; }

  /* ---------- browser only from here ---------- */

  var CART = root.WowCartConfig;
  var CFG = root.WowSubpopConfig;
  // Arm A keeps Rebuy's popup, untouched.
  if (!CART || !CFG || CART.arm !== 'B') return;

  var doc = root.document;
  var el, refs = {};
  var offer = null;          // the line the open popup is about
  var run = 0;               // newest add wins when two land close together
  var busy = false;
  var lastFocus = null;
  var productCache = {};

  function money(c) { return formatMoney(c, CFG.moneyFormat); }

  // XMLHttpRequest on purpose, not fetch: the shipping-protection app (Mule)
  // only re-prices its checkout button after an XHR (storefront/wow-cart/README.md).
  function api(path, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new root.XMLHttpRequest();
      xhr.open(body ? 'POST' : 'GET', path);
      xhr.setRequestHeader('Accept', 'application/json');
      if (body) xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        var json = null;
        try { json = JSON.parse(xhr.responseText); } catch (e) { /* handled below */ }
        if (xhr.status >= 200 && xhr.status < 300 && json) { resolve(json); return; }
        var err = new Error((json && (json.description || json.message)) || 'Cart error');
        err.data = json;
        reject(err);
      };
      xhr.onerror = function () { reject(new Error('Network error')); };
      xhr.send(body ? JSON.stringify(body) : null);
    });
  }

  // Review stars and subscription plans come from the wow-cart-product section
  // (sections/wow-cart-product.liquid, owned by the cart).
  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = root.fetch(CFG.root.replace(/\/$/, '') + '/products/' + handle + '?section_id=wow-cart-product')
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-wow-cart-product[^>]*>([\s\S]*?)<\/script>/);
        return JSON.parse(m[1]);
      })
      .catch(function () { delete productCache[handle]; return null; });
    return productCache[handle];
  }

  /* ---------- notice the shopper's Add to cart ---------- */

  function onAdd(json) {
    var item;
    try { item = offerItem(json); } catch (e) { item = null; }
    if (item && item.handle) show(item);
  }

  // Wraps whatever is there (the cart's and Mule's wrappers included) and
  // hands the call on untouched; it only reads a copy of the answer.
  function watchAdds() {
    var innerFetch = root.fetch;
    root.fetch = function (input) {
      var p = innerFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (isCartAdd(url)) {
          p.then(function (r) {
            if (r && r.ok) r.clone().json().then(onAdd).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) { /* never break the page's own request */ }
      return p;
    };
    var open = root.XMLHttpRequest.prototype.open;
    root.XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartAdd(url)) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try {
            onAdd(this.responseType === 'json' ? this.response : JSON.parse(this.responseText));
          } catch (e) { /* not JSON: nothing to offer */ }
        });
      }
      return open.apply(this, arguments);
    };
  }

  /* ---------- the popup ---------- */

  function img(src, width) {
    if (!src) return '';
    var u = String(src).replace(/^https?:/, '');
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function renderProduct(item, product) {
    var url = (product.url || ('/products/' + item.handle)) + '?variant=' + item.variant_id;
    var title = item.product_title || product.title;
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var full = item.original_price || item.price;
    var review = Number(product.rating_count) > 0
      ? '<div aria-label="product star rating" class="wow-subpop__review">' +
          '<span class="wow-subpop__stars">' +
            '<span class="wow-subpop__sr">' + escapeHtml(product.rating) + ' stars out of 5 stars</span> ' +
            '<span class="wow-subpop__stars-bg"></span> ' +
            '<span class="wow-subpop__stars-fill" style="width: ' + starPercent(product.rating).toFixed(4) + '%;"></span>' +
          '</span> ' +
          '<span class="wow-subpop__count">\n<span>(</span>\n<span>' + Number(product.rating_count) + '</span>\n' +
          '<span>Reviews</span>\n<span>)</span></span>' +
        '</div>'
      : '';
    return '' +
      '<div class="wow-subpop__media">' +
        '<a href="' + escapeHtml(url) + '" class="wow-subpop__image">' +
          (item.image ? '<img src="' + escapeHtml(img(item.image, 400)) + '" alt="View ' + escapeHtml(title) + '">' : '') +
        '</a>' +
      '</div> ' +
      '<div class="wow-subpop__info">' +
        '<h5 class="wow-subpop__product-title"><a href="' + escapeHtml(url) + '" aria-label="View ' + escapeHtml(title) + '">' +
          escapeHtml(title) + '</a></h5> ' +
        (variant ? '<div class="wow-subpop__variant">' + escapeHtml(variant) + '</div> ' : '') +
        review + ' ' +
        '<div class="wow-subpop__price"><div>' +
          '<span class="wow-subpop__money wow-subpop__money--sale"><span class="wow-subpop__sr">Sale price</span> ' +
            '<span>' + money(offerPrice(full, CFG.displayPercent)) + '</span></span> ' +
          '<span class="wow-subpop__money wow-subpop__money--compare"><span class="wow-subpop__sr">Original price</span> ' +
            '<span>' + money(full) + '</span></span>' +
        '</div></div>' +
      '</div> ' +
      '<div class="wow-subpop__actions">' +
        '<div class="wow-subpop__frequency"><select aria-label="subscription frequency" class="wow-subpop__select" data-wow-subpop-plan>' +
          product.selling_plans.map(function (p) {
            return '<option value="' + escapeHtml(p.id) + '">' + escapeHtml(p.name) + '</option>';
          }).join('') +
        '</select></div> ' +
        '<button alt="Add ' + escapeHtml(title) + ' to Cart" type="button" class="wow-subpop__button" data-wow-subpop-accept>' +
          '<span>' + CFG.language.accept + '</span></button> ' +
        '<button type="button" class="wow-subpop__button wow-subpop__button--decline" data-wow-subpop-decline>' +
          '<span>' + CFG.language.decline + '</span></button>' +
      '</div>';
  }

  function show(item) {
    var mine = ++run;
    getProduct(item.handle).then(function (product) {
      if (mine !== run) return;
      // No subscription plans on this product: nothing to offer, same as Rebuy.
      if (!product || !product.selling_plans || !product.selling_plans.length) return;
      offer = item;
      busy = false;
      refs.product.innerHTML = renderProduct(item, product);
      open();
    });
  }

  function open() {
    if (el.hidden) lastFocus = doc.activeElement;
    el.hidden = false;
    // reading the width forces a layout, so the fade-in runs
    void el.offsetWidth;
    el.classList.add('is-visible');
    doc.documentElement.classList.add('wow-subpop-open');
    refs.content.focus();
  }

  function close() {
    run++;
    offer = null;
    el.classList.remove('is-visible');
    doc.documentElement.classList.remove('wow-subpop-open');
    setTimeout(function () { if (!el.classList.contains('is-visible')) el.hidden = true; }, 500);
    if (lastFocus && lastFocus.focus && doc.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  function isOpen() { return !el.hidden && el.classList.contains('is-visible'); }

  function accept(button) {
    if (busy || !offer) return;
    busy = true;
    var item = offer;
    var label = button.querySelector('span');
    var planId = refs.product.querySelector('[data-wow-subpop-plan]').value;
    button.classList.add('is-working');
    button.disabled = true;
    label.textContent = CFG.language.adding;
    api('/cart.js')
      .then(function (cart) {
        var line = findLine(cart, item);
        if (!line) throw new Error('The item is no longer in the cart');
        return api('/cart/change.js', changePayload(line, planId, CFG.lineProperties));
      })
      .then(function () {
        label.textContent = CFG.language.added;
        close();
        // The cart drawer notices the change on its own; this covers the case
        // where it is shut or has not started.
        if (root.WowCart && root.WowCart.ready && root.WowCart.refresh) root.WowCart.refresh().catch(function () {});
      })
      .catch(function (e) {
        // The shopper still has the one-time line; let them try again or decline.
        busy = false;
        button.classList.remove('is-working');
        button.disabled = false;
        label.textContent = CFG.language.accept;
        if (root.console) root.console.error('[wow-subpop] switch failed', e);
      });
  }

  function focusable() {
    var f = refs.content.querySelectorAll('a[href], button:not([disabled]), select, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
  }

  function bind() {
    el.addEventListener('click', function (ev) {
      var t = ev.target;
      // a click on the dimmed backdrop itself, not on the box
      if (t === refs.overlay) { close(); return; }
      if (t.closest('[data-wow-subpop-close]') || t.closest('[data-wow-subpop-decline]')) { close(); return; }
      var yes = t.closest('[data-wow-subpop-accept]');
      if (yes) accept(yes);
    });
    doc.addEventListener('keydown', function (ev) {
      if (!isOpen()) return;
      if (ev.key === 'Escape') {
        // Rebuy's Escape shuts the popup and the cart behind it in one go.
        close();
        if (root.WowCart && root.WowCart.ready && root.WowCart.close) root.WowCart.close();
        return;
      }
      if ((ev.key === 'Enter' || ev.key === ' ') && ev.target.closest && ev.target.closest('[data-wow-subpop-close]')) {
        ev.preventDefault();
        close();
        return;
      }
      if (ev.key !== 'Tab') return;
      var f = focusable();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (ev.shiftKey && (doc.activeElement === first || doc.activeElement === refs.content)) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && doc.activeElement === last) { ev.preventDefault(); first.focus(); }
    });
    // The cart drawer opens a moment after the add and takes the focus with
    // it; while the popup is up the focus belongs here.
    doc.addEventListener('focusin', function (ev) {
      if (isOpen() && !el.contains(ev.target)) refs.content.focus();
    });
  }

  /* ---------- keep Rebuy's popup shut ---------- */

  function retireRebuyPopup() {
    var id = String(CFG.rebuyWidgetId);
    function widget() {
      var list = (root.Rebuy && root.Rebuy.widgets) || [];
      for (var i = 0; i < list.length; i++) if (String(list[i].id) === id) return list[i];
      return null;
    }
    function shut() {
      try {
        var w = widget();
        if (w && w.data && w.data.visible && typeof w.hide === 'function') w.hide();
      } catch (e) { /* the CSS keeps it out of sight regardless */ }
      // Rebuy locks the page scroll for its popup; with the popup hidden by
      // our CSS the shopper could never unlock it.
      if (doc.body) doc.body.classList.remove('rebuy-modal-visible');
    }
    function onShow(ev) {
      var w = ev && ev.detail && ev.detail.widget;
      if (w && String(w.id) !== id) return;
      shut();
      // Rebuy flips its popup to visible 100ms after it announces it.
      setTimeout(shut, 150);
    }
    doc.addEventListener('rebuy.show', onShow);
    shut();
  }

  function start() {
    try {
      el = doc.getElementById('wow-subpop');
      if (!el) return;
      refs = {
        overlay: el.querySelector('[data-wow-subpop-overlay]'),
        content: el.querySelector('[data-wow-subpop-content]'),
        product: el.querySelector('[data-wow-subpop-product]')
      };
      if (!refs.overlay || !refs.content || !refs.product) return;
      bind();
      watchAdds();
      root.WowSubpop = { ready: true, close: close };
      doc.documentElement.classList.add('wow-subpop-ready');
      retireRebuyPopup();
      // Have the product on hand before the shopper presses Add to cart.
      if (CFG.productHandle) getProduct(CFG.productHandle);
    } catch (e) {
      // Anything going wrong here must leave the shopper with Rebuy's popup.
      doc.documentElement.classList.remove('wow-subpop-ready');
      if (root.WowSubpop) root.WowSubpop.ready = false;
      if (root.console) root.console.error('[wow-subpop] start failed', e);
    }
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : this);
